import React from 'react';

const Logo = ({ className = "", variant = "default" }: { className?: string, variant?: "default" | "light" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/images/GeoMetrix_LOGO_FULL.png" 
        alt="Geometrix Logo" 
        className={`h-12 w-auto ${variant === "light" ? "brightness-0 invert" : ""}`}
        style={{ maxWidth: '200px' }}
      />
    </div>
  );
};

export default Logo;